<script setup>
import { computed } from 'vue';
import { frontendURL } from 'dashboard/helper/URLHelper';
import { dynamicTime } from 'shared/helpers/timeHelper';

import CardLayout from 'dashboard/components-next/CardLayout.vue';

const props = defineProps({
  id: { type: [String, Number], default: '' },
  name: { type: String, default: '' },
  description: { type: String, default: '' },
  claimCode: { type: String, default: '' },
  systemStage: { type: String, default: '' },
  category: { type: String, default: '' },
  accountId: { type: [String, Number], default: 0 },
  updatedAt: { type: Number, default: 0 },
});

const navigateTo = computed(() =>
  frontendURL(`accounts/${props.accountId}/planning/lost-objects/${props.id}`)
);

const updatedAtTime = computed(() =>
  props.updatedAt ? dynamicTime(props.updatedAt) : ''
);
</script>

<template>
  <router-link :to="navigateTo">
    <CardLayout
      layout="col"
      class="[&>div]:justify-start [&>div]:gap-2 [&>div]:px-4 [&>div]:pt-4 [&>div]:pb-5 [&>div]:items-start hover:bg-n-slate-2 dark:hover:bg-n-solid-3"
    >
      <div class="min-w-0 flex-1 flex flex-col items-start gap-2 w-full">
        <div class="flex items-center min-w-0 justify-between gap-2 w-full">
          <div class="flex items-center gap-2 min-w-0">
            <h5
              class="text-sm font-medium leading-4 truncate min-w-0 text-n-slate-12"
            >
              {{ name }}
            </h5>
            <span
              v-if="claimCode"
              class="text-xs font-mono text-n-slate-9 flex-shrink-0"
            >
              {{ claimCode }}
            </span>
          </div>
          <span
            class="text-xs inline-flex items-center font-medium rounded-md whitespace-nowrap capitalize bg-n-alpha-2 px-1.5 h-6 text-n-slate-12 flex-shrink-0"
          >
            {{ category || systemStage }}
          </span>
        </div>
        <p
          v-if="description"
          class="text-sm text-n-slate-11 line-clamp-2 w-full"
        >
          {{ description }}
        </p>
        <span v-if="updatedAt" class="text-xs text-n-slate-9">
          {{ $t('SEARCH.UPDATED_AT', { time: updatedAtTime }) }}
        </span>
      </div>
    </CardLayout>
  </router-link>
</template>
